// @ts-nocheck
export default (startDate: Date, endDate: Date) => {
    if (!endDate) {
        return null;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    const startDateLocalTZ = start.toLocaleDateString("en-US", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        timeZone: "Etc/UTC",
    });
    const endDateLocalTZ = end.toLocaleDateString("en-US", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        timeZone: "Etc/UTC",
    });

    if (startDateLocalTZ === endDateLocalTZ) {
        return false;
    }

    return true;
};
